exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___2D-gc .index-module__top___3xmTa{display:grid;grid-template-columns:1fr auto;align-items:start}.index-module__wrapper___2D-gc .index-module__top___3xmTa .index-module__label___3RxdV{text-transform:uppercase;font-weight:500;letter-spacing:.5px;margin-bottom:.75em;font-size:15px}.index-module__wrapper___2D-gc .index-module__top___3xmTa .index-module__name___16rjA{font-size:21px;font-weight:400;margin-bottom:1em}.index-module__wrapper___2D-gc .index-module__top___3xmTa .index-module__date___2Zi7G{font-size:16px;font-weight:500;margin-bottom:1em}.index-module__wrapper___2D-gc .index-module__sign-in-button-wrapper___kNhkN{display:flex;gap:1em;align-items:center}.index-module__wrapper___2D-gc .index-module__registration-closed___OuM-k{background-color:#1e265c;color:#fff;border-radius:5px;padding:.5em}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___2D-gc",
	"top": "index-module__top___3xmTa",
	"label": "index-module__label___3RxdV",
	"name": "index-module__name___16rjA",
	"date": "index-module__date___2Zi7G",
	"sign-in-button-wrapper": "index-module__sign-in-button-wrapper___kNhkN",
	"registration-closed": "index-module__registration-closed___OuM-k"
};